export const ADD_TO_CART = 'ADD_TO_CART';

export const ADD_TO_CART_REQUEST = 'ADD_TO_CART_REQUEST';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_RESET = 'ADD_TO_CART_RESET';
export const ADD_TO_CART_FAIL = 'ADD_TO_CART_FAIL';

export const GET_CART_ITEMS_REQUEST = 'GET_CART_ITEMS_REQUEST';
export const GET_CART_ITEMS_SUCCESS = 'GET_CART_ITEMS_SUCCESS';
export const GET_CART_ITEMS_FAIL = 'GET_CART_ITEMS_FAIL';

export const REMOVE_CART_ITEM_REQUEST = 'REMOVE_CART_ITEM_REQUEST';
export const REMOVE_CART_ITEM_SUCCESS = 'REMOVE_CART_ITEM_SUCCESS';
export const REMOVE_CART_ITEM_RESET = 'REMOVE_CART_ITEM_RESET';
export const REMOVE_CART_ITEM_FAIL = 'REMOVE_CART_ITEM_FAIL';

export const REMOVE_ALL_CART_ITEMS_REQUEST = 'REMOVE_ALL_CART_ITEMS_REQUEST';
export const REMOVE_ALL_CART_ITEMS_SUCCESS = 'REMOVE_ALL_CART_ITEMS_SUCCESS';
export const REMOVE_ALL_CART_ITEMS_FAIL = 'REMOVE_ALL_CART_ITEMS_FAIL';

export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';



export const SAVE_SHIPPING_INFO = 'SAVE_SHIPPING_INFO';

export const CLEAR_ERRORS = 'CLEAR_ERRORS';